import { render, staticRenderFns } from "./InvoiceContent.vue?vue&type=template&id=8ed079fc&"
import script from "./InvoiceContent.vue?vue&type=script&lang=ts&"
export * from "./InvoiceContent.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceContent.vue?vue&type=style&index=0&id=8ed079fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports